import React from 'react';
import {Typography} from '@fupa/fupa-uikit';
import styled from 'styled-components';
import {ErrorData} from 'app/components/team/playerstats/types';

const Container = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100%;
  width: 100%;
`;

interface NoRowsOverlayProps {
  error: ErrorData;
}

export default function NoRowsOverlay({error}: NoRowsOverlayProps) {
  return (
    <Container>
      <Typography variant='body1'>
        {error ? 'Beim Laden der Daten ist ein Fehler aufgetreten.' : 'Es sind noch keine Statistiken vorhanden.'}
      </Typography>
    </Container>
  );
}
